// import stompjs from "stompjs";
import webstomp from "webstomp-client";
import SockJS from "sockjs-client";

const SET_SOCKET = "/websocket/SET_SOCKET";
const SET_SUBSCRIPTION = "/websocket/SET_SUBSCRIPTION";
const REMOVE_SUBSCRIPTION = "/websocket/REMOVE_SUBSCRIPTION";

const initState = {
  userSocket: null,
  equipmentSocket: null,
  subscriptions: {}
};

export const websocket = (state = initState, action) => {
  switch(action.type) {
    case SET_SOCKET: {
      if (action.data.type === "user") {
        return {
          ...state,
          userSocket: action.data.socket
        };
      }
      if (action.data.type === "equipment") {
        return {
          ...state,
          equipmentSocket: action.data.socket
        }
      }
      return state
    }
    case SET_SUBSCRIPTION: {
      let newSubscriptions = Object.assign({}, state.subscriptions);
      newSubscriptions[action.data.key] = action.data.value;
      return {
        ...state,
        subscriptions: newSubscriptions
      };
    }
    case REMOVE_SUBSCRIPTION: {
      let newSubscriptions = Object.assign({}, state.subscriptions);
      delete newSubscriptions[action.data];
      console.log("websocket: newSubscriptions", action.data, newSubscriptions);
      return {
        ...state,
        subscriptions: newSubscriptions
      }
    }
    default:
      return state;
  }
};

//用户服务
export const subscribeWebsocket = (url, callback) => (dispatch, getState) => {
  if (getState().websocket.userSocket === null) {
    let socket = SockJS("/sia-user-websocket");
    let stompClient = webstomp.over(socket);
    stompClient.connect({}, function(frame) {
      let subscriptionId = stompClient.subscribe(url, callback);
      console.log("subscriptionId:", subscriptionId);
      dispatch(setSocket("user", stompClient));
      dispatch(setSubscription({key: url, value: subscriptionId}));
    });
  } else {
    if (getState().websocket.subscriptions[url]) {
      console.log("DEBUG: already subscribed:", url);
    } else {
      console.log("DEBUG: websocket has already been created, just subscribe.");
      let subscriptionId = getState().websocket.userSocket.subscribe(url, callback);
      dispatch(setSubscription({key: url, value: subscriptionId}));
    }
  }
};

//数据采集服务
export const subscribeWebsocket1 = (url, callback) => (dispatch, getState) => {
  if (getState().websocket.equipmentSocket === null) {
    let socket = SockJS("/sia-equipment-websocket");
    let stompClient = webstomp.over(socket);
    stompClient.connect({}, function(frame) {
      let subscriptionId = stompClient.subscribe(url, callback);
      console.log("subscriptionId:", subscriptionId);
      dispatch(setSocket("equipment", stompClient));
      dispatch(setSubscription({key: url, value: subscriptionId}));
    });
  } else {
    if (getState().websocket.subscriptions[url]) {
      console.log("DEBUG: already subscribed:", url);
    } else {
      console.log("DEBUG: websocket has already been created, just subscribe.");
      let subscriptionId = getState().websocket.equipmentSocket.subscribe(url, callback);
      dispatch(setSubscription({key: url, value: subscriptionId}));
    }
  }
};

export const unsubscribeWebsocket = (url) => (dispatch, getState) => {
  console.log("unsubscribe", getState().websocket);

  let subscriptionId = getState().websocket.subscriptions[url];
  if (subscriptionId) {
    subscriptionId.unsubscribe();
    dispatch(removeSubscription(url));
    console.log("DEBUG: websocket found url, unsubscribe ->", url, getState().websocket.subscriptions);
    if (Object.keys(getState().websocket.subscriptions).length === 0) {
      console.log("DEBUG: websocket not has no subscription, just close.", getState().websocket.userSocket);
      if (getState().websocket.userSocket !== null) {
        getState().websocket.userSocket.disconnect(frame => console.log("disconnect", frame), {});
        dispatch(setSocket("user", null));
      }

      console.log("DEBUG: websocket not has no subscription, just close.", getState().websocket.equipmentSocket);
      if (getState().websocket.equipmentSocket !== null) {
        getState().websocket.equipmentSocket.disconnect(frame => console.log("disconnect", frame), {});
        dispatch(setSocket("equipment", null));
      }
    }
  }
  else
    console.error("ERROR: no subscription found:", url);
};

export const setSocket = (type, socket) => {
  return {
    type: SET_SOCKET,
    data: {
      type,
      socket
    }
  }
};

export const setSubscription = (data) => {
  return {
    type: SET_SUBSCRIPTION,
    data: data
  }
};

export const removeSubscription = (data) => {
  return {
    type: REMOVE_SUBSCRIPTION,
    data: data
  }
};
